import { EventRepository } from '~repositories/EventRepository';
import { events } from '@estee/elc-service-bus';
import serviceNames from '~setup/AnalyticsService';
import { diContainer } from '~setup/diContainer';
import { Event } from '~entities/Event';

export class CreateAccountFailUseCase {
    private eventRepository: EventRepository;
    private error: string;

    constructor(error: string) {
        this.eventRepository = diContainer.get(serviceNames.eventRepository);
        this.error = error;
    }

    public execute = () => {
        const createAccountFailPayload = {
            event_name: 'create_account_fail',
            event_category: 'account',
            event_action: 'create account fail',
            event_label: `standard - ${this.error}`
        };

        const newEvent = new Event({
            id: this.eventRepository.generateId(),
            name: events.CREATE_ACCOUNT_FAIL,
            type: 'link',
            payload: createAccountFailPayload
        });

        this.eventRepository.addEventToQueue(newEvent);
    };
}
